<template>
    <b-card
        text-variant="white"
        :title="product.name"
        v-if="product.active"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave"
        :class="trailer(product) ? 'with-video' : ''"
    >
        <picture
            v-if="product.image"
        >
            <source
                :srcset="assetPath + '/images/cards/' + product.image + '-2x.webp'"
                type="image/webp"
            >
            <source
                :srcset="assetPath + '/images/cards/' + product.image + '-4x.png 1600w, ' + assetPath + '/images/cards/' + product.image + '-2x.png 540w, ' + assetPath + '/images/cards/' + product.image + '-1x.png 367w'"
                type="image/png"
            >
            <img
                :src="assetPath + '/images/cards/' + product.image + '-1x.png'"
                :srcset="assetPath + '/images/cards/' + product.image + '-4x.png 1600w, ' + assetPath + '/images/cards/' + product.image + '-2x.png 540w, ' + assetPath + '/images/cards/' + product.image + '-1x.png 367w'"
                :alt="product.name"
                loading="lazy"
                class="card-img"
                @load="lazyLoaded = true"
            />
        </picture>
        <div
            v-if="trailer(product)"
            class="rooms__room-video"
        >
            <div
                :id="'youtube-player-' + trailer(product)"
            ></div>
        </div>
        <div class="carousel-products__product-top">
            <div v-if="product.locale_price.price < product.locale_price.price_original"
                 class="carousel-products__product-label carousel-products__product-label-discount carousel-products__product-label-red"
                 v-html="'-' + calculateDiscount(product.locale_price.price, product.locale_price.price_original) + '%'"></div>
            <div v-if="product.label"
                 class="carousel-products__product-label carousel-products__product-label-purple"
                 v-html="product.label"></div>
        </div>
        <b-card-text>
            <div class="row">
                <div class="col-6"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi b-icon bi-clock-fill" style="margin-right: .5rem;" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                </svg>{{ product.rooms[0].time }} {{ __('minuten') }}</div>
                <div class="col-6 text-right align-self-end">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-puzzle-fill" viewBox="0 0 16 16" v-for="n in roomDifficulty(product.rooms[0])" style="margin-left: .275rem">
                        <path d="M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .036-.054l.003-.01v-.008a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003l-.003-.01a.214.214 0 0 0-.036-.053.859.859 0 0 0-.27-.194C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.036.054l-.003.01v.002l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855z"/>
                    </svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-puzzle" viewBox="0 0 16 16" v-for="n in parseInt(5 - roomDifficulty(product.rooms[0]))" style="margin-left: .275rem">
                    <path d="M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .039-.063v-.009a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003a.214.214 0 0 0-.039-.064.859.859 0 0 0-.27-.193C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.039.063v.003l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855zM4.605 3a.5.5 0 0 0-.498.55l.001.007.29 3.4A.5.5 0 0 1 3.9 7.5h-.782c-.696 0-1.182-.497-1.469-.872a.459.459 0 0 0-.118-.115.112.112 0 0 0-.025-.012L1.5 6.5h-.003a.213.213 0 0 0-.064.039.86.86 0 0 0-.193.27C1.1 7.09 1 7.51 1 8c0 .491.1.912.24 1.19.07.14.14.225.194.271a.213.213 0 0 0 .063.039H1.5l.006-.001a.112.112 0 0 0 .025-.012.459.459 0 0 0 .118-.115c.287-.375.773-.872 1.469-.872H3.9a.5.5 0 0 1 .498.542l-.29 3.408a.5.5 0 0 0 .497.55h1.878c-.048-.166-.195-.352-.463-.557-.274-.21-.52-.528-.52-.943 0-.568.447-.947.862-1.154C6.807 10.123 7.387 10 8 10s1.193.123 1.638.346c.415.207.862.586.862 1.154 0 .415-.246.733-.52.943-.268.205-.415.39-.463.557h1.878a.5.5 0 0 0 .498-.55l-.001-.007-.29-3.4A.5.5 0 0 1 12.1 8.5h.782c.696 0 1.182.497 1.469.872.05.065.091.099.118.115.013.008.021.01.025.012a.02.02 0 0 0 .006.001h.003a.214.214 0 0 0 .064-.039.86.86 0 0 0 .193-.27c.14-.28.24-.7.24-1.191 0-.492-.1-.912-.24-1.19a.86.86 0 0 0-.194-.271.215.215 0 0 0-.063-.039H14.5l-.006.001a.113.113 0 0 0-.025.012.459.459 0 0 0-.118.115c-.287.375-.773.872-1.469.872H12.1a.5.5 0 0 1-.498-.543l.29-3.407a.5.5 0 0 0-.497-.55H9.517c.048.166.195.352.463.557.274.21.52.528.52.943 0 .568-.447.947-.862 1.154C9.193 5.877 8.613 6 8 6s-1.193-.123-1.638-.346C5.947 5.447 5.5 5.068 5.5 4.5c0-.415.246-.733.52-.943.268-.205.415-.39.463-.557H4.605z"/>
                </svg>
                </div>
            </div>
            <div class="row">
                <div class="col-6"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi b-icon bi-person-fill" style="margin-right: .5rem;" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                </svg>{{ product.rooms[0].min_users }} - {{ product.rooms[0].max_users }} {{ __('personen') }}</div>
                <div
                    v-if="product.rooms[0].active"
                    class="col-6 text-right align-self-end"
                >
                                            <span class="price-sale" v-if="product.locale_price.price < product.locale_price.price_original">
                                                {{ product.locale_price.locale.currency_symbol }}{{ product.locale_price.price_original }}
                                            </span>
                    {{ product.locale_price.locale.currency_symbol }}{{ product.locale_price.price | toPrice }} {{ __('per groep') }}
                </div>
            </div>
        </b-card-text>
    </b-card>
</template>

<script>
export default {
    name: "RoomComponent",
    props: {
        product: {
            type: Object
        },
    },
    data() {
        return {
            player: null,
            playerReady: false,
            lazyLoaded: false,
            videoShouldBeLoaded: false
        }
    },
    computed: {
        assetPath() {
            return process.env.ASSET_PATH || "";
        }
    },
    mounted() {
        if(this.trailer(this.product)) {
            this.waitForYTToLoad();
        }
    },
    methods: {
        waitForYTToLoad(){
            if(typeof window.YT !== "undefined" && window.YT.loaded){
                this.$nextTick(() => {
                    this.loadVideo();
                });
            }
            else{
                setTimeout(this.waitForYTToLoad, 250);
            }
        },
        insertVideo()
        {
            const youtubeApiId = 'youtube-iframe-api';
            this.videoShouldBeLoaded = true;

            if(!window.YT) { // If not, load the script asynchronously
                if (!document.getElementById(youtubeApiId)) {
                    const tag = document.createElement('script');
                    tag.src = 'https://www.youtube.com/iframe_api';
                    tag.id = youtubeApiId;

                    const firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                }
            } else {
                this.loadVideo();
            }
        },
        loadVideo()
        {
            this.$nextTick(() => {
                if(window.YT.Player) {
                    this.player = new window.YT.Player('youtube-player-' + this.trailer(this.product), {
                        videoId: this.trailer(this.product),
                        playerVars: {
                            'playsinline': 1,
                            'controls': 0,
                            'rel': 0,
                            'enablejsapi': 1,
                            'modestbranding': 1,
                            'showinfo': 0,
                            'disablekb': 1,
                            'iv_load_policy': 3,
                            'loop': 1,
                            'playlist': this.trailer(this.product)
                        },
                        events: {
                            onReady: this.videoReady,
                            onEnded: this.videoEnded
                        },
                    });
                }
            });
        },
        videoReady()
        {
            this.playerReady = true;
            if(typeof this.player?.playVideo === "function") {
                this.player.mute();
                this.player.playVideo();
                setTimeout(() => {
                    this.player.pauseVideo();
                }, 1800);
            }
        },
        videoEnded()
        {
            this.player?.seekTo(0);
        },
        mouseOver()
        {
            if(this.playerReady) {
                if(typeof this.player?.playVideo === "function") {
                    this.player.playVideo();
                }
            } else {
                if(!this.videoShouldBeLoaded) {
                    this.$nextTick(() => {
                        this.insertVideo();
                    });
                }
            }
        },
        mouseLeave()
        {
            if(this.playerReady) {
                setTimeout(() => {
                    if(typeof this.player?.pauseVideo === "function") {
                        this.player.pauseVideo();
                    }
                }, 300);
            }
        },
        trailer(product)
        {
            const room = product.rooms[0];
            const language = window.locale.language;

            if(room && room.trailer) {
                const trailerUrl = room.trailer[language];
                if(trailerUrl) {
                    return trailerUrl.split('/embed/')[1];
                }
            }

            return null;
        },
        calculateDiscount(current_price, original_price)
        {
            return Math.round((original_price - current_price) / original_price * 100);
        },
        roomDifficulty(room) {
            if(room.difficulty) {
                return room.difficulty;
            } else {
                return 0;
            }
        },
    }
}
</script>

<style scoped>

</style>
